var exports = {
  "WD": "x234b8571--a60d94--labels",
  "Vv": "x234b8571--a60d94--label-item",
  "Pf": "x234b8571--a60d94--label",
};

module.exports = exports;
